/* eslint-disable no-nested-ternary */
/* eslint-disable multiline-ternary */
// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { useTable, usePagination } from 'react-table';

// Components
import { ErrorCard } from '../../components';
import FakeLoader from '../FakeLoader';
import Pagination from './Pagination';

// Styles
import './table.scss';

const Table = ({
    filter,
    tableTitle,
    tableHead,
    tableCell,
    pageSizeOptions,
    columns,
    data,
    fetchData,
    isFiltersEnable,
    isPaginationEnable,
    loading,
    roleStatus,
    pageCount: controlledPageCount,
    paginationLabel,
    userActions,
    pagePerView,
    tableSubSection,
    error,
    isResetPage,
    afterResetPage,
    filterData,
    id,
    tableSummary,
    isPGRepoTab,
    tableCard,
    emptyTitle,
    emptyDescription
}) => {
    const {
        headers,
        getTableProps,
        getTableBodyProps,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        // Get the state from the instance
        state,
    } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: 0, pageSize: 10 },
            // Pass our hoisted table state
            autoResetPage: true,
            manualPagination: true,
            // Tell the usePagination
            // hook that we'll handle our own data fetching
            // This means we'll also have to provide our own
            // pageCount.
            pageCount: controlledPageCount,
        },
        usePagination
    );
    const { pageIndex, pageSize } = state;

    // console.log("tableWrapp---->", controlledPageCount);

    React.useEffect(() => {
        if (isResetPage && isPGRepoTab === true) {
            state.pageIndex = 0;
            state.pageSize = 50;
        }
        if (isResetPage && isPGRepoTab !== true) {
            state.pageIndex = 0;
            state.pageSize = 10;
        }
        return () => {
            afterResetPage && afterResetPage();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isResetPage]);

    // Listen for changes in pagination and use the state to fetch our new data
    React.useEffect(() => {
        fetchData({ pageIndex: pageIndex + 1, pageSize, roleStatus });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageIndex,
        pageSize,
        roleStatus,
        state.pageIndex,
        state.pageSize,
        filterData,
    ]);

    const incrementValue = 1;
    const pagesCount = [...Array(pageOptions.length).keys()].map(
        value => value + incrementValue
    );

    return (
        <React.Fragment>
            {/* Dynamic Filter Element prop */}
            {isFiltersEnable ? filter : null}
            {tableSummary ? tableSummary : null}
            {tableCard ? tableCard : <></>}
            <div className={`tableWrapper ${ tableTitle === 'PG Credentials Repository' ? 'pg-creds-table-class' : ''   }`} id={id}>
                {/* Dynamic TableHead Element prop */}
                {tableHead || null}
                {tableSubSection && tableSubSection ? tableSubSection() : null}
                {loading ? <FakeLoader withMask /> : null}
                {!loading && error ? (
                    <ErrorCard text={error} />
                ) : (
                    <table {...getTableProps()}>
                        <thead>
                            <tr>
                                {headers.map(header => (
                                    <th key={header.id} className={header.id} style={(header?.column?.width) ? { width: header.column.width, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } : {}}>
                                        {header.header}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page && page.length ? (
                                page.map(row => {
                                    prepareRow(row);
                                    return (
                                        <tr {...row.getRowProps()}>
                                            {row.cells.map((cell, index) => (
                                                <React.Fragment key={index}>
                                                    <td
                                                        {...cell.getCellProps()}
                                                        style={(cell?.column?.width) ? { width: cell.column.width, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } : {}}
                                                    >
                                                        {tableCell(
                                                            cell,
                                                            userActions,
                                                            row
                                                        )}
                                                    </td>
                                                </React.Fragment>
                                            ))}
                                        </tr>
                                    );
                                })
                            ) : (
                                <div />
                            )}
                        </tbody>
                    </table>
                )}
                {!loading && !error ? (
                    (page && page.length) || loading ? null : (
                        <ErrorCard
                            isNoResult
                            emptyTitle={emptyTitle}
                            emptyDescription={emptyDescription}
                        />
                    )
                ) : null}
            </div>
            {isPaginationEnable ? (
                <Pagination
                    id={id}
                    pageSize={pageSize}
                    pageSizeOptions={pageSizeOptions}
                    previousPage={previousPage}
                    canPreviousPage={canPreviousPage}
                    pagesCount={pagesCount}
                    gotoPage={gotoPage}
                    nextPage={nextPage}
                    canNextPage={canNextPage}
                    setPageSize={setPageSize}
                    pageIndex={pageIndex}
                    paginationLabel={paginationLabel}
                    pagePerView={pagePerView}
                />
            ) : null}
        </React.Fragment>
    );
};

Table.propTypes = {
    actionTitle: PropTypes.string,
    tableHead: PropTypes.node,
    columns: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    fetchData: PropTypes.func.isRequired,
    filter: PropTypes.node,
    tableSummary: PropTypes.node,
    isFiltersEnable: PropTypes.bool,
    isPaginationEnable: PropTypes.bool,
    loading: PropTypes.bool,
    onClickTableAction: PropTypes.func,
    pageCount: PropTypes.number,
    pagePerView: PropTypes.number,
    pageSizeOptions: PropTypes.array,
    paginationLabel: PropTypes.string,
    roleStatus: PropTypes.string,
    setRoleStatus: PropTypes.func,
    tableCell: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    tableFilters: PropTypes.node,
    tableSubSection: PropTypes.node,
    title: PropTypes.string,
    userActions: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    error: PropTypes.string,
    isResetPage: PropTypes.object,
    afterResetPage: PropTypes.func,
    filterData: PropTypes.object,
    id: PropTypes.string,
};

export default Table;
